import { Check, SkipForward, Circle } from "lucide-react";

export const PvpStepNav = ({ steps, current, status, summaryDone, onSelect }) => (
  <nav className="md:sticky md:top-6 self-start" data-testid="pvp-step-nav">
    <ol className="border-l border-zinc-900">
      {steps.map((s, i) => {
        const st = s.key === "summary" ? (summaryDone ? "done" : "") : status[s.key];
        const active = i === current;
        return (
          <li key={s.key}>
            <button
              onClick={() => onSelect(i)}
              className={`w-full text-left flex items-center gap-2 pl-4 pr-2 py-2 text-sm -ml-px border-l-2 transition-colors ${active ? "border-zinc-900 font-semibold bg-zinc-50" : "border-transparent text-zinc-600 hover:text-zinc-900"}`}
              data-testid={`pvp-step-${s.key}`}
              data-status={st || "open"}
            >
              <span className="font-mono text-[10px] text-zinc-400 w-4">{String(i + 1).padStart(2, "0")}</span>
              <span className="flex-1">{s.title}</span>
              {st === "done" && <Check className="h-3.5 w-3.5 text-emerald-600" />}
              {st === "skipped" && <SkipForward className="h-3.5 w-3.5 text-amber-600" />}
              {!st && <Circle className="h-3 w-3 text-zinc-300" />}
            </button>
          </li>
        );
      })}
    </ol>
    <div className="mt-4 font-mono text-[10px] text-zinc-400 space-y-1 pl-4">
      <div className="flex items-center gap-1"><Check className="h-3 w-3 text-emerald-600" /> ingevuld</div>
      <div className="flex items-center gap-1"><SkipForward className="h-3 w-3 text-amber-600" /> overgeslagen</div>
    </div>
  </nav>
);
